<template>
  <div class="layout-header">
    <h3 class="pull-left" @click="$router.push('/index')">后台管理系统</h3>

    <el-button
      @click="deleteLoginStatus"
      style="margin-top: 14px; margin-right: 20px"
      class="pull-right"
      size="small"
      type="danger"
      >退出登录</el-button
    >

    <el-button
      @click="handleChangePassword"
      style="margin-top: 14px; margin-right: 20px"
      class="pull-right"
      size="small"
    >
      修改密码
    </el-button>

    <el-button
      @click="handleDataSync"
      style="margin-top: 14px; margin-right: 20px"
      class="el-icon-sort pull-right"
      size="small"
    >
      数据同步
    </el-button>
    <el-button
      @click="handleDataSyncNew"
      style="margin-top: 14px; margin-right: 20px"
      class="el-icon-sort pull-right"
      size="small"
    >
      数据同步新测试
    </el-button>

    <div class="button-config pull-right">
      <router-link to="/config">
        <i class="el-icon-setting"></i>
      </router-link>
    </div>
    <div
      class="box-tips pull-right"
      v-if="box_num"
      @click="$router.push('/case_sold_out')"
    >
      存在下架盒子:{{ box_num }}
    </div>

    <div
      class="box-tips pull-right caton"
      v-if="catonNum"
      @click="$router.push('/battle_caton_room')"
    >
      存在卡顿的房间:{{ catonNum }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { server, postData, delData, patchData, getData, getApiData, postApiData, patchApiData, api } from '@/http'
export default {
  data() {
    return {
      visible: false,
      buttonLoading: false,
      password: '',
      visibleInfo: false,
      canalsInfo: null,
      box_num: '',//下架盒子数量
      catonNum: '',//对战卡顿房间数量
    }
  },
  created() {
    this.getSoldOutBox()//获取下架盒子数据
    this.getCatonRoom()//获取对战卡顿房间数据
  },
  methods: {
    ...mapActions(['deleteLoginStatus']),
    handleDataSync() {
      this.$confirm('此操作将会把正式服数据同步到测试服务器, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await postData('data_sync')
          return this.$message.success(res.status)
        } catch (e) {
        }
      }).catch(() => {
        return this.$message({
          type: 'info',
          message: '已取消同步'
        })
      })
    },
    handleDataSyncNew() {
      this.$confirm('此操作将会把正式服数据同步到新测试服务器, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await postData('data_sync_new')
          return this.$message.success(res.status)
        } catch (e) {
        }
      }).catch(() => {
        return this.$message({
          type: 'info',
          message: '已取消同步'
        })
      })
    },
    handleChangePassword() {
      let password
      let password_confirmation
      this.$prompt('', '修改密码', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          if (!value || value.length <= 6) {
            this.$message.error('请输入6位以上的密码')
            throw new Error('请输入6位以上的密码')
          }
          password = value
        })
        .then(() => {
          return this.$prompt('', '确认密码', {
            confirmButtonText: '确定修改',
            cancelButtonText: '取消'
          })
        })
        .then(({ value }) => {
          if (password !== value) {
            this.$message.error('两次密码输入不一致')
            throw new Error('两次密码输入不一致')
          }
          password_confirmation = value
          return patchData('admins', {
            password,
            password_confirmation
          })
        }).then(res => {
          this.$message.success('修改成功')
        })
    },
    //获取下架盒子数据
    getSoldOutBox() {
      getApiData('box_shelves_record').then(res => {
        this.box_num = res.total
      })
        .finally(() => {
        })
    },
    //获取对战卡顿房间数据
    getCatonRoom() {
      getApiData('battle_room_block').then(res => {
        if (res) {
          this.catonNum = res.total
        }
      }).finally(() => {
      })
    },
  }
}
</script>
<style lang="less" scoped>
.layout-header {
  .box-tips {
    margin-right: 20px;
    cursor: pointer;
    color: red;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      text-decoration: underline;
    }
    &.caton {
      color: rgb(22, 129, 252);
    }
  }
}
</style>
